import { render } from "./Notice.vue?vue&type=template&id=0edfb74f&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"

import "./Notice.vue?vue&type=style&index=0&id=0edfb74f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0edfb74f"

export default script